import { jsx as r, jsxs as c, Fragment as G } from "react/jsx-runtime";
import { forwardRef as J, useState as K } from "react";
import n from "./input.module.less.js";
import { InputElementTopSection as Q } from "../components/input-element-top-section/input-element-top-section.js";
import R from "../components/input-skeleton-loader/input-skeleton-loader.js";
import { Checkbox as X } from "../checkbox-group/checkbox-group.js";
import { useTranslation as Y } from "react-i18next";
const l = J(
  ({
    name: e,
    value: o,
    isValid: s,
    errorText: u,
    isDisabled: a,
    isReadOnly: i,
    isRequired: x,
    label: b,
    placeholder: P,
    helperText: T,
    autoComplete: y,
    inputMode: N,
    type: f,
    className: k,
    inputClassName: C,
    iconRight: d,
    minLength: W,
    maxLength: j,
    pattern: g,
    onChange: p,
    onFocus: m,
    onBlur: I,
    onKeyDown: h,
    onKeyUp: w,
    isLoading: E,
    onClickIconRight: v,
    min: O,
    max: _
  }, A) => {
    const F = () => !!(x && s === !1 || s === !1 && o), B = (t) => {
      v && typeof v == "function" && v();
    }, D = (t) => {
      p && typeof p == "function" && p(t);
    }, H = (t) => {
      m && typeof m == "function" && m(t);
    }, L = (t) => {
      I && typeof I == "function" && I(t);
    }, M = (t) => {
      w && typeof w == "function" && w(t);
    }, U = (t) => {
      h && typeof h == "function" && h(t);
    }, $ = () => {
      if (N)
        return N;
      if (f === "number")
        return "numeric";
    }, S = F(), q = d ? n.withIcon : "", z = a || i;
    return /* @__PURE__ */ r("div", { className: [n.wrapper, k, a && n.disabled, "space-mb-md"].join(" "), children: /* @__PURE__ */ c("div", { className: n.innerWrapper, children: [
      /* @__PURE__ */ r(
        Q,
        {
          label: b,
          helperText: T,
          errorText: S ? u : void 0,
          htmlFor: e
        }
      ),
      /* @__PURE__ */ c("div", { className: n.inputWrapper, children: [
        E ? /* @__PURE__ */ r(R, {}) : /* @__PURE__ */ c(G, { children: [
          S && /* @__PURE__ */ r("div", { className: n.errorIndicator }),
          /* @__PURE__ */ r(
            "input",
            {
              className: [
                n.input,
                C,
                S ? n.error : "",
                q ? n.withIcon : ""
              ].join(" "),
              "aria-required": !!x,
              ref: A,
              id: e || void 0,
              type: f || "text",
              value: o || "",
              name: e,
              pattern: g,
              disabled: a,
              inputMode: $(),
              placeholder: P,
              autoComplete: y || "off",
              onChange: (t) => D(t),
              onFocus: (t) => H(t),
              onBlur: (t) => L(t),
              onKeyUp: (t) => M(t),
              onKeyDown: (t) => U(t),
              minLength: W,
              maxLength: j,
              readOnly: i,
              min: O,
              max: _
            }
          )
        ] }),
        d && /* @__PURE__ */ r(
          "button",
          {
            disabled: z,
            onClick: B,
            className: [n.icon, d].join(" ")
          }
        )
      ] })
    ] }) });
  }
);
l.displayName = "Input";
const Z = (e) => /* @__PURE__ */ r(l, { ...e }), V = (e) => /* @__PURE__ */ r(
  l,
  {
    ...e,
    iconRight: e.value ? "ui-icon-close" : "ui-icon-search",
    onClickIconRight: e.value ? e.onClickClear : void 0
  }
), tt = (e) => {
  const [o, s] = K(!1), { t: u } = Y(), a = (i) => {
    i.target.checked ? s(!0) : s(!1);
  };
  return /* @__PURE__ */ c("div", { className: `${n.inputPasswordWrapper} space-mb-md`, children: [
    /* @__PURE__ */ r(l, { ...e, type: o ? "text" : "password" }),
    /* @__PURE__ */ r(
      X,
      {
        label: u("INPUT_PASSWORD_SHOW_PASSWORD"),
        name: "password",
        isChecked: o,
        onChange: a
      }
    )
  ] });
}, ct = {
  Text: Z,
  Password: tt,
  Search: V
};
export {
  ct as Input
};
